// src/pages/Users/Retailers.jsx
import React from 'react';
import UserManagement from './UserManagement';

const Retailers = () => {
  return <UserManagement role="retailer" title="Retailer" />;
};

export default Retailers;